/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODOffcanvas from "./../../components/offcanvas.js";

var ODLayoutAside = function() {
    // Private properties
    var _body;
    var _element;
    var _offcanvasObject;

    // Private functions
	// Initialize
	var _init = function() {
		var offcanvasClass = ODUtil.hasClass(_element, 'aside-offcanvas-default') ? 'aside-offcanvas-default' : 'aside';

        // Initialize mobile aside offcanvas
		_offcanvasObject = new ODOffcanvas(_element, {
			baseClass: offcanvasClass,
			overlay: true,
			closeBy: 'od_aside_close_btn',
			toggleBy: {
				target: 'od_aside_mobile_toggle',
				state: 'mobile-toggle-active'
			}
		});
	}

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);
            _body = ODUtil.getBody();

            if (!_element) {
                return;
            }

            // Initialize
            _init();
        },

        getElement: function() {
            return _element;
        },

        getOffcanvas: function() {
            return _offcanvasObject;
        },

        isFixed: function() {
            return ODUtil.hasClass(_body, 'aside-fixed');
        },

        isMinimized: function() {
            return (ODUtil.hasClass(_body, 'aside-fixed') && ODUtil.hasClass(_body, 'aside-minimize'));
        },

        isHoverable: function() {
            return (ODUtil.hasClass(_body, 'aside-fixed') && ODUtil.hasClass(_body, 'aside-minimize-hoverable'));
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutAside;
}

export default ODLayoutAside;
